'use strict';


/*Object.defineProperty(exports, "__esModule", {
  value: true
});*/

const axios = require('axios');
const mobileProviders = {
"Android" : {path: './mobileProviders/Android', widgetCheckout: false},
"iOS" : {path: './mobileProviders/iOS', widgetCheckout: false}
};
const webProviders = {
"PaymentWall": {path: () => './webProviders/PaymentWall', widgetCheckout: true},	
"PayPal": {path: 'webProviders/PayPal', widgetCheckout: true},	
"Stripe": {path: 'webProviders/Stripe', widgetCheckout: true}	
};


exports.StoreClientApi = function(options, products, fatalErrorCallback){
	this.host = options.host;
	this.mobileEnable = options.mobileEnable;
	this.fecb = fatalErrorCallback;
	if(this.mobileEnable == null || this.mobileEnable == '' || this.mobileEnable == undefined) {
		this.mobileEnable = false;
	}
	this.webPaymentEnable = options.webPaymentEnable;
	if(this.webPaymentEnable == null || this.webPaymentEnable == '' || this.webPaymentEnable == undefined) {
		this.webPaymentEnable = false;
	}	
	this.products = products;
	this.provider = null;
	this.providerIden = options.provider;
	this.cb = null;
	this.checkOrderStatusQueue = [];
	this.checkOrderStatusIndex = null;
	this.classProvider = null;
	this.eventPage = null;
	this.token = '';
	this.instance = axios.create({
      baseURL: this.host,
      timeout: 5000,
      responseType: 'json'
    });
    this.messages = [];

//returning codes:
//900: OK
//901: unauthorized request
//904: not found
//905: network error
//906: internal error
//907: failed request
this.initProvider = function (opt, restoreMessages) {
	if(restoreMessages != null && restoreMessages!=undefined){
		this.messages = restoreMessages;
	}
	 
	if(this.mobileEnable) {
	//this.provider = new require(mobileProviders[this.providerIden].path)();		
	if ( this.providerIden == 'Android' ) {
	this.classProvider = require('./mobileProviders/Android');
	} else {
	this.classProvider = require('./mobileProviders/iOS');
	}
	}else{
	//this.provider = new require(webProviders[this.providerIden].path)();		
	if ( this.providerIden == 'PaymentWall' ) {
	this.classProvider = require('./webProviders/PaymentWall');
	} else if ( this.providerIden == 'Stripe' ){
	this.classProvider = require('./webProviders/Stripe');
	} else {
	this.classProvider = require('./webProviders/PayPal');		
	}
	}
	this.provider = new this.classProvider();
	return this.provider.init(opt, this.products, this);
}
this.getProducts = function () {
	return this.provider.getProducts();
}
// callback could be called with the following codes and could or not return a widget code 
// 799: transaction ordered.
// 800: transaction done, and validated, credits the goods
// 801: transaction done, pending validation. do not credits the good yet, wait for new call for validation happen in our out the callback
// 804: transaction failed
// on mobile, only productsSelected[0] is used
this.doCheckout = function (productsSelected, couponData, cb) {
	this.provider.doCheckout(productsSelected, couponData, cb);		
}

this.getCheckoutForm = function (options, cb) {
	this.provider.getCheckoutForm(options, (r) => {
		if(r == 0){
			cb({code: 905});
		} else {
			cb(r);			
		}
		});
} 

this.callService = function (path, params, cb) {
     this.instance.post("/" + path, Object.assign({}, params, {token: this.token}))
    .then((response) => {
	cb({code: 900, data: response.data});		  
	}).catch(function (error) {
    cb({code: 905, error: error}, true);
    });				
}

this.updateToken = function (token) {
	this.token = token;
}

this.checkCoupon = function (couponCode, cb) {
	this.instance.post('/api/store/getCoupon', {token: this.token, couponCode: couponCode})
    .then((response) => {
	cb(response.data);		  
	}).catch(function (error) {
    cb({code: 905}, true);
    });
}

this.redeemCoupon = function (couponCode, cb) {
	this.instance.post('/api/store/redeemCoupon', {token: this.token, couponCode: couponCode})
    .then((response) => {
	cb(response.data);		  
	}).catch(function (error) {
    cb({code: 905}, true);
    });		
}

this.payWithCredits = function (products, extraData, cb) {
     this.instance.post('/api/auth/payWithCredits', {token: this.token, products: JSON.stringify(products), dataObj: JSON.stringify(extraData)})
    .then((response) => {
	cb(response.data);		  
	}).catch(function (error) {
    cb({code: 905}, true);
    });			
}
this.subscribeEvent = function (cb) {
	this.eventPage = cb;
}
this.resumeActivity = function (r) {
	if(this.eventPage != null) {
	this.eventPage({type: 'resume', result: r});
	}
	if(this.provider != null) {
	this.provider.resumeActivity();
	}
}
this.orderedProduct = function () {
	this.messages.push({code: 799});
	// this.cb({code: 799});
}
this.errorOrder = function () {
	this.messages.push({code: 804});
	//this.cb({code: 804});	
}
this.approvedProduct =  function (p) {
	this.messages.push(Object.assign({}, {code: 801}, {product: p}));
	if(this.eventPage != null) {
		this.eventPage({type: 'approved', result: p});
	}	
	// this.cb(Object.assign({}, {code: 801}, {product: p}));
}
this.cancelledProduct = function (p) {
	if(this.eventPage != null) {
		this.eventPage({type: 'cancel', result: p});
	}
}

this.errorProduct = function (p) {
	if(this.eventPage != null) {
		this.eventPage({type: 'error', result: p});
	}	
}

this.finishedProduct =  function (p) {
	this.messages.push(Object.assign({}, {code: 800}, {product: p}));
	// this.cb(Object.assign({}, {code: 800}, {product: p}));
}
this.getMessages = function(eraseMsgs) {
	return this.messages;
	if(eraseMsgs == true) {
		this.messages = [];
	}
}
this.updateValidatorURL = function (url) {
	this.provider.updateValidatorURL(url);
}
this.startCheckOrderStatus = function (url, iden, cb) {
	this.checkOrderStatusQueue.push({url: url, iden: iden, cb: cb});
	if(this.checkOrderStatusIndex == null) {
		this.checkOrderStatusIndex = setInterval(() => { this.checkOrderStatus() }, 2000)
	}
	return this.checkOrderStatusQueue.length - 1;
}

this.checkOrderStatus = function () {
	for(var i = 0; i < this.checkOrderStatusQueue.length; i++){
		this.callService(this.checkOrderStatusQueue[i].url, {iden: this.checkOrderStatusQueue[i].iden}, this.checkOrderStatusQueue[i].cb);
	}
}
this.clearOrderStatus = function(index) {
		this.checkOrderStatusQueue.splice(index, 1);
		if(this.checkOrderStatusIndex != null && this.checkOrderStatusQueue.length > 0){
			clearInterval(this.checkOrderStatusIndex);
			this.checkOrderStatusIndex = null;
		}
}
this.executeCallbackProducts = function (productsOrder) {
             for(var f = 0; f < productsOrder.length; f++) {
               for(var h = 0; h < this.products.length; h++) {
                 if(productsOrder[f] == this.products[h].id) {
                   if(this.products[h].cb != null) {
                     this.products[h].cb()
                   }
                 }
               }
             }
 }
this.fatalerror = function (obj) {
	this.fecb(obj);
} 	
};
